import { createContext } from 'react';

const value = {
  ids: [],
  mixedContent: [],
  loadingBookmarkedMixedContent: true,
  toggleBookmark() {
    return null;
  },
  getIsBookmarkedByUser() {
    return undefined;
  },
};

export const BookmarkContext = createContext(value);
